import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";
import { z } from "zod";

export const AddOrderSchema = z.object({
  service: z.string().min(3),
  customer: z.string(),
  employee: z.string().min(3),
  plateNumber: z.string().min(3),
  company: z.string().min(3),
  addOns: z.array(z.string()),
});

export type AddOrderSchemaType = z.infer<typeof AddOrderSchema>;

export async function addOrderService(formData: AddOrderSchemaType) {
  try {
    const response = await axiosInstance.post(
      `${config.apiUrl}/orders`,
      formData
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data);
    } else {
      console.error("Unknown error:", error);
    }
    throw error;
  }
}
